import React from 'react';

import './Card.css'

export default function CustomCard({ children, ...attributes }) {
  return (
    <div 
        className='card'
        {...attributes}
    >
        
        {children}
            
        </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/CustomCard.jsx